const config = {
  company: 'Heinrich Grotemeier GmbH & Co. KG' || 'vib GmbH',
  logoURI:
    'https://utils.vib-development.ch/grotemeier/logo.svg' || 'https://utils.vib-development.ch/vib/logo.svg',
  logoWhiteURI:
    'https://utils.vib-development.ch/grotemeier/logo.svg' || 'https://utils.vib-development.ch/vib/logo-white.svg',

  address: 'Heinrich Grotemeier GmbH & Co. KG,Teichstr. 29,D-32257 Bünde'?.split(',') || [
    'vib GmbH',
    'Grabenstrasse 12',
    '6340 Baar',
  ],
  contact: 'Telefon 0 52 23,info@grotemeier.de'?.split(',') || [
    '+41 (0)41 763 16 94',
    'support@vib-gmbh.ch',
  ],
  apibaseuri:
    'https://api.grotemeier-manual.vib-connect.de' ||
    'https://api.main.vib-connect-manual.ch4.amazee.io',
  appname: 'Heinrich Grotemeier GmbH & Co. KG ECM Manual' || 'vib connect Manual',
  appdomain: 'grotemeier-manual.vib-connect.de' || 'manual.vib-gmbh.ch',
  appurl: 'https://grotemeier-manual.vib-connect.de' || 'https://manual.vib-gmbh.ch',
  statuspage: 'https://status.vib-development.ch' || 'https://status.vib-development.ch',
  support: 'support@vib-connect.de' || 'support@vib-gmbh.ch',
  root: '1086YLhX0OKnErBq0No_H4_2ZCZSq6264' || '',
  footer: '1PwiLJ4LtQS137s30aXkZuwLuRPNni_AUcMeP4bw1Xl0' || '',
  disclaimer: '1AtXDDOKwoy2DjzeBxPnv0nh0sDx1N_1sMyRkyIOQMhI' || '',
  languages: 'DE'?.split(',') || ['DE','EN-GB'],
  screenBreak: '930' || 930
};

export default config;
